import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const navLinks = [
    { path: '/about', label: '私たちについて' },
    { path: '/order-bridal', label: 'オーダー・ブライダル' },
    { path: '/shop', label: 'ジュエリー販売' },
    { path: '/company', label: '会社概要' },
    { path: '/contact', label: 'お問い合わせ' },
  ];

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-white/85 backdrop-blur-sm'
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center">
              <h1 className="text-xl lg:text-2xl font-serif font-semibold text-brown-600 whitespace-nowrap">
                ジュエリーおかやま株式会社
              </h1>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-brown-600 hover:text-brown-400 transition-colors font-serif text-base whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </nav>

            {/* Desktop Contact */}
            <div className="hidden lg:flex items-center">
              <a
                href="tel:086-012-3456"
                className="flex items-center space-x-2 px-6 py-2.5 border-2 border-brown-400 text-brown-600 rounded-lg hover:bg-brown-400 hover:text-white transition-all font-serif whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-lg"></i>
                <span>086-012-3456</span>
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden w-10 h-10 flex items-center justify-center text-brown-600 cursor-pointer"
              aria-label="メニュー"
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 lg:hidden">
          <div className="absolute inset-0 bg-brown-600/95 backdrop-blur-sm pt-20">
            <nav className="flex flex-col items-center justify-center space-y-6 py-12">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-white text-2xl font-serif hover:text-cream-100 transition-colors"
                >
                  {link.label}
                </Link>
              ))}
              <a
                href="tel:086-012-3456"
                className="flex items-center space-x-3 text-white text-2xl font-serif hover:text-cream-100 transition-colors"
              >
                <i className="ri-phone-line"></i>
                <span>086-012-3456</span>
              </a>
            </nav>
          </div>
        </div>
      )}
    </>
  );
}